const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MasterDataCommand: any = {
    AddPlatform: `${Backofficebff}/v1/globaldata/create-platform`,
    DeletePlatform: `${Backofficebff}/v1/globaldata/delete-platform`,
    UpdatePlatform: `${Backofficebff}/v1/globaldata/update-platform`,
};
